import styles from './webkua-lib.module.scss';

/* eslint-disable-next-line */
export interface WebkuaLibProps { }

export function WebkuaLib(props: WebkuaLibProps) {
  return (
    <div className={styles['container']}>
      <h1>Welcome to WebkuaLib!</h1>
    </div>
  );
}

export default WebkuaLib;